export default __webpack_public_path__ + "static/media/Swiftshank Treads.a217fb3b.jpg";